export default __webpack_public_path__ + "static/media/closeIconWhite.2d2e8119.svg";